var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 116,
    viewBox: "0 0 114 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_703_24003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.57617 8.69922C1.57617 4.28094 5.15789 0.699219 9.57617 0.699219H17.2125C21.6308 0.699219 25.2125 4.28094 25.2125 8.69922V117.234H1.57617V8.69922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.57617 86.3906C1.57617 81.9723 5.15789 78.3906 9.57617 78.3906H17.2125C21.6308 78.3906 25.2125 81.9723 25.2125 86.3906V117.236H1.57617V86.3906Z",
    fill: "#63658E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_703_24003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8066 8.69922C44.8066 4.28094 48.3884 0.699219 52.8066 0.699219H61.0002C65.4185 0.699219 69.0002 4.28094 69.0002 8.69922V117.234H44.8066V8.69922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8066 101.93C44.8066 97.5114 48.3884 93.9297 52.8066 93.9297H61.0002C65.4185 93.9297 69.0002 97.5114 69.0002 101.93V117.237H44.8066V101.93Z",
    fill: "#63658E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_703_24003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.5879 8.69922C88.5879 4.28094 92.1696 0.699219 96.5879 0.699219H104.411C108.83 0.699219 112.411 4.28094 112.411 8.69922V117.234H88.5879V8.69922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5879 47.5469C88.5879 43.1286 92.1696 39.5469 96.5879 39.5469H104.411C108.83 39.5469 112.411 43.1286 112.411 47.5469V117.237H88.5879V47.5469Z",
    fill: "#63658E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_703_24003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 116,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_703_24003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 116,
    fill: "white",
    transform: "translate(44)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_703_24003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 116,
    fill: "white",
    transform: "translate(87)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/barChart.bdfa918de56af511ea2e234314ddc286.svg";
export { ForwardRef as ReactComponent };